export { useHotelDiningCarousel } from './use-hotel-dining-carousel';
